import recurringTypes from './recurringTypes'

export const initialState = {
  filters: {
    originState: '',
    destState: '',
    equipmentType: '',
    dispatcherName: '',
    offset: 0
  },
  loadMore: false,
  loadPage: true,
  error: '',
  recurrings: [],
  noMore: false,
  addLoading: false,
  addError: '',
  editLoading: false,
  editError: '',
  deleteLoad: false,
  deleteError: ''
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case recurringTypes.GET_RECURRING:
      return {
        ...state,
        loadMore: true,
        error: ''
      }

    case recurringTypes.GET_RECURRING_SUCCESS: {
      const { offset } = state.filters

      let { data: recurrings, results } = payload
      const noMore = recurrings.length < results

      if (offset !== 0) {
        recurrings = [...state.recurrings, ...recurrings]
      }

      return {
        ...state,
        recurrings,
        noMore,
        loadMore: false,
        loadPage: false,
        error: ''
      }
    }

    case recurringTypes.GET_RECURRING_FAILURE: {
      return {
        ...state,
        loadMore: false,
        loadPage: false,
        error: payload,
        recurrings: []
      }
    }

    case recurringTypes.CLEAR_RECURRING: {
      return {
        ...state,
        recurrings: []
      }
    }

    case recurringTypes.LOAD_MORE:
      return {
        ...state,
        filters: {
          ...state.filters,
          offset: state.filters.offset + payload
        },
        loadMore: true
      }

    case recurringTypes.SET_FILTERS : {
      const filters = (!payload) ? { ...initialState.filters } : {
        ...state.filters,
        ...payload,
        offset: 0
      }

      return {
        ...state,
        filters,
        loadPage: true
      }
    }

    case recurringTypes.ADD_RECURRING_TRACTOR:
      return {
        ...state,
        addLoading: true,
        addError: ''
      }

    case recurringTypes.ADD_RECURRING_TRACTOR_SUCCESS: {
      const newRecurringTractor = {
        ...payload,
        origin: {
          ...payload.origin,
          state_code: payload.origin.state_id
        },
        destination: payload.destination ? {
          ...payload.destination,
          state_code: payload.destination.state_id
        } : null
      }
      return {
        ...state,
        recurrings: [newRecurringTractor, ...state.recurrings],
        addLoading: false,
        addError: ''
      }
    }

    case recurringTypes.ADD_RECURRING_TRACTOR_FAILURE:
      return {
        ...state,
        addLoading: false,
        addError: payload
      }

    case recurringTypes.UPDATE_RECURRING_TRACTOR:
      return {
        ...state,
        editLoading: true,
        editError: ''
      }

    case recurringTypes.UPDATE_RECURRING_TRACTOR_SUCCESS: {
      const updatedRecurringTractor = {
        ...payload,
        origin: {
          ...payload.origin,
          state_code: payload.origin.state_id || payload.origin.state_code
        },
        destination: payload.destination ? {
          ...payload.destination,
          state_code: payload.destination.state_id || payload.origin.state_code
        } : null
      }
      const newRecurrings = state.recurrings.map(tractor => tractor.recurring_tractor_id === payload.recurring_tractor_id ? updatedRecurringTractor : tractor)
      return {
        ...state,
        recurrings: newRecurrings,
        editLoading: false,
        editError: ''
      }
    }

    case recurringTypes.UPDATE_RECURRING_TRACTOR_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: payload
      }

    case recurringTypes.DELETE_RECURRING_TRACTOR:
      return {
        ...state,
        deleteLoad: true,
        deleteError: ''
      }

    case recurringTypes.DELETE_RECURRING_TRACTOR_SUCCESS: {
      const recurrings = state.recurrings.filter(({ recurring_tractor_id }) => recurring_tractor_id !== payload)
      return {
        ...state,
        deleteLoad: false,
        deleteError: '',
        recurrings
      }
    }

    case recurringTypes.DELETE_RECURRING_TRACTOR_FAILURE:
      return {
        ...state,
        deleteLoad: false,
        deleteError: payload
      }

    default: return state
  }
}
